import { ShareButton } from '../web-components/share-button';